"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.TextContainer = exports.Text = exports.LogoAndTextContainer = exports.HBProTipContainer = exports.CompanyLogo = exports.CloseIcon = exports.ActionContainer = exports.Action = void 0;
exports["default"] = HBProTip;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("styled-is"));
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _animations = require("../../styles/animations");
var _breakpoints = require("../../styles/breakpoints");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _HBMediaElement = _interopRequireDefault(require("../HBMediaElement/HBMediaElement"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _templateObject, _templateObject2;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LOGO_SIZE = 54;
/** @deprecated Please use MemberToast from ToastStore: `type: ToastType.MemberToast` */
function HBProTip(_ref) {
  var className = _ref.className,
    iconUrl = _ref.iconUrl,
    title = _ref.title,
    text = _ref.text,
    action = _ref.action,
    textType = _ref.textType,
    hideClose = _ref.hideClose,
    autoDismissMs = _ref.autoDismissMs;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    animateIn = _useState2[0],
    setAnimateIn = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showProtip = _useState4[0],
    setShowProtip = _useState4[1];
  var timeoutRef = (0, _react.useRef)(null);
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isDoneShowing = _useState6[0],
    setIsDoneShowing = _useState6[1];
  (0, _react.useEffect)(function () {
    if (!isDoneShowing && autoDismissMs) {
      timeoutRef.current = setTimeout(function () {
        setIsDoneShowing(true);
        setAnimateIn(false);
      }, autoDismissMs);
      return function () {
        clearTimeout(timeoutRef.current);
      };
    }
    return null;
  }, [isDoneShowing, autoDismissMs]);
  var handleClose = function handleClose() {
    setAnimateIn(false);
  };
  var handleAnimationEnd = function handleAnimationEnd() {
    if (!animateIn) {
      setShowProtip(false);
    }
  };
  if (!showProtip) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(HBProTipContainer, {
    className: className,
    animateIn: animateIn,
    onAnimationEnd: handleAnimationEnd
  }, !hideClose && /*#__PURE__*/_react["default"].createElement(CloseIcon, {
    color: _colors["default"].neutral800,
    onClick: handleClose
  }), /*#__PURE__*/_react["default"].createElement(LogoAndTextContainer, null, iconUrl && /*#__PURE__*/_react["default"].createElement(CompanyLogo, null, /*#__PURE__*/_react["default"].createElement(_HBMediaElement["default"], {
    width: LOGO_SIZE,
    height: LOGO_SIZE,
    path: iconUrl,
    crop: "fit"
  })), /*#__PURE__*/_react["default"].createElement(TextContainer, null, title && /*#__PURE__*/_react["default"].createElement(Title, null, title), /*#__PURE__*/_react["default"].createElement(Text, {
    type: textType || 'Body6DarkPrimary'
  }, text))), action && /*#__PURE__*/_react["default"].createElement(ActionContainer, null, action));
}

// -------------------------------- Styles -------------------------------- //
var HBProTipContainer = exports.HBProTipContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBProTip__HBProTipContainer",
  componentId: "sc-n99pxy-0"
})(["max-width:100%;margin:0 4px;z-index:3;padding:", ";background-color:", ";border-radius:8px;box-shadow:0 15px 40px 0 rgba(40,63,136,0.15),0 3px 10px 0 rgba(40,63,136,0.05);position:sticky;bottom:", ";", "{max-width:420px;margin:0 auto;}", "{position:fixed;right:", ";min-width:350px;}", " ", ";", ""], _spacing["default"][20], _colors["default"].white, _spacing["default"][20], _breakpoints.smallUp, _breakpoints.mediumUp, _spacing["default"][20], (0, _styledIs["default"])('animateIn')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    animation: ", " 1s;\n    "])), (0, _animations.fromDirection)('down')), (0, _styledIs.isNot)('animateIn')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    animation: ", " 0.7s;\n    "])), (0, _animations.dissolve)('up')), _mixins.hideInPrint);
var CloseIcon = exports.CloseIcon = (0, _styledComponents["default"])(_Close["default"]).withConfig({
  displayName: "HBProTip__CloseIcon",
  componentId: "sc-n99pxy-1"
})(["position:absolute;top:", ";right:", ";"], _spacing["default"][12], _spacing["default"][12]);
var CompanyLogo = exports.CompanyLogo = _styledComponents["default"].div.withConfig({
  displayName: "HBProTip__CompanyLogo",
  componentId: "sc-n99pxy-2"
})(["min-width:", "px;height:", "px;", ";border-radius:50%;border:1px solid ", ";opacity:0.7;margin-right:", ";overflow:hidden;"], LOGO_SIZE, LOGO_SIZE, _mixins.flexCenterAll, _colors["default"].black_01, _spacing["default"][12]);
var LogoAndTextContainer = exports.LogoAndTextContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBProTip__LogoAndTextContainer",
  componentId: "sc-n99pxy-3"
})(["display:flex;align-items:top;"]);
var TextContainer = exports.TextContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBProTip__TextContainer",
  componentId: "sc-n99pxy-4"
})(["", " margin-top:", ";margin-right:", ";"], _mixins.flexColumn, _spacing["default"][4], _spacing["default"][20]);
var Title = exports.Title = (0, _styledComponents["default"])(_HBText["default"]).attrs({
  type: 'title14'
}).withConfig({
  displayName: "HBProTip__Title",
  componentId: "sc-n99pxy-5"
})(["display:block;margin-bottom:", ";"], _spacing["default"][4]);
var Text = exports.Text = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBProTip__Text",
  componentId: "sc-n99pxy-6"
})(["display:block;white-space:pre-line;"]);
var ActionContainer = exports.ActionContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBProTip__ActionContainer",
  componentId: "sc-n99pxy-7"
})(["margin-top:", ";display:flex;justify-content:flex-end;button{margin-bottom:0;}"], _spacing["default"][12]);
var Action = exports.Action = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBProTip__Action",
  componentId: "sc-n99pxy-8"
})([""]);
//# sourceMappingURL=HBProTip.js.map